import './style.css';

console.log('Vite + WordPress Theme loaded!');

// Define an array of components to be loaded
// Each object specifies the data-component attribute value and the dynamic import function
const componentsToLoad = [
  {
    name: 'Reviews Carousel', // For logging purposes
    selector: 'reviews-carousel',
    importer: () => import('./components/reviews-carousel/reviews-carousel.js')
  },
  {
    name: 'Tabs',
    selector: 'tabs',
    importer: () => import('./components/tabs/tabs.js')
  },
  {
    name: 'Event Hero',
    selector: 'event-hero-video',
    importer: () => import('./components/event-hero/event-hero.js')
  },
  {
    name: 'Event Mini Nav',
    selector: 'event-mini-nav',
    importer: () => import('./components/event-mini-nav/event-mini-nav.js')
  },
  {
    name: 'Desktop Menu',
    selector: 'desktop-menu',
    importer: () => import('./components/desktop-menu/desktop-menu.js')
  },
  {
    name: 'Mobile Menu',
    selector: 'mobile-menu',
    importer: () => import('./components/mobile-menu/mobile-menu.js')
  },
  {
    name: 'Calendar Carousel',
    selector: 'calendar-carousel',
    importer: () => import('./components/calendar-carousel/calendar-carousel.js')
  },
  {
    name: 'Accordion',
    selector: 'accordion',
    importer: () => import('./components/accordion/accordion.js')
  },
  {
    name: 'Event Listing',
    selector: 'event-listing',
    importer: () => import('./components/event-listing/event-listing.js')
  },
  {
    name: 'Calendar',
    selector: 'calendar',
    importer: () => import('./components/calendar/calendar.js')
  },
  // Add more components here as needed
];

// Example: Dynamically import component-a when an element with ID 'component-a-container' exists
document.addEventListener('DOMContentLoaded', () => {
  componentsToLoad.forEach(async ({ name, selector, importer }) => {
    // Find all elements with the specific data-component attribute
    const componentNodes = document.querySelectorAll(`[data-component="${selector}"]`);

    if (componentNodes.length > 0) {
      try {
        // Dynamically import the component's JavaScript file
        // This 'await' ensures the component JS is loaded only once, even if there are multiple nodes
        const { default: initComponent } = await importer();

        // Iterate over each found node and initialize the component
        componentNodes.forEach(node => {
          // You can also pass data from other data-attributes if needed
          // e.g., const options = node.dataset.options ? JSON.parse(node.dataset.options) : {};
          // initComponent(node, options);
          initComponent(node);
        });
        console.log(`${name} initialized for ${componentNodes.length} instance(s).`);
      } catch (error) {
        console.error(`Failed to load ${name} component (selector: ${selector}):`, error);
      }
    } else {
      console.log(`No instances of ${name} component (selector: ${selector}) found on this page.`);
    }
  });
});
